export default __webpack_public_path__ + "static/media/support.dc2dd7d8.png";